//
//
//
//
//
//
//
//

export default {
    name: 'MyBtnReturn',
    props: {
        routerName: String,
        query: Object,
        step: Number
        // step: {
        //   type: Number,
        //   default: -1
        // },
    },
    data() {
        return {}
    },
    methods: {
        handleReturn() {
            // this.$router.push({
            //   name: this.routerName,
            //   query: this.query || {}
            // })

            // 回退按钮要弄成类似浏览器的回退按钮，不然IOS端的微信自带回退按钮会乱
            if (this.step) {
                // history.go(this.step)
                this.$router.go(this.step)
            } else {
                // history.go(-1)
                this.$router.go(-1)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/subComponents/MyBtnReturn.vue